import onSearchInputFocused from '../actions/onSearchInputFocused';
import onSearchRefinersToggled from '../actions/onSearchRefinersToggled';
import onSuggestionSelected from '../actions/onSuggestionSelected';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';
import {
    onEnterPressedSearchInput,
    onEscapePressedSearchInput,
} from '../actions/onKeyDownSearchInput';

mutator(onSearchInputFocused, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible = true;
});

mutator(onSuggestionSelected, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible = false;
});

mutator(onEnterPressedSearchInput, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible = false;
});

mutator(onEscapePressedSearchInput, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible = false;
});

mutator(onSearchRefinersToggled, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).isSuggestionsDropdownVisible = false;
});
